module.exports = __webpack_public_path__ + "img/food-33.5ec06059.jpg";